/**
 * Cài đặt → Gói & hạn mức: gói hiện tại của tổ chức và mức đã dùng (chỉ xem — đổi gói do
 * quản trị nền tảng thực hiện).
 */
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { api } from '@/lib/api-client'

interface HanMuc {
  goi: { key: string; ten: string; moTa: string } | null
  gioiHan: { nickZalo: number | null; nguoiDung: number | null; webhook: number | null; tenMienRieng: number | null; anThuongHieuNenTang: boolean }
  dangDung: { nickZalo: number; nguoiDung: number; webhook: number; tenMienRieng: number }
}

const DONG: Array<{ k: 'nickZalo' | 'nguoiDung' | 'webhook' | 'tenMienRieng'; ten: string }> = [
  { k: 'nguoiDung', ten: 'Người dùng' },
  { k: 'nickZalo', ten: 'Nick Zalo cá nhân' },
  { k: 'webhook', ten: 'Webhook ra ngoài' },
  { k: 'tenMienRieng', ten: 'Tên miền riêng' },
]

export function GoiDichVuTab() {
  const { data } = useQuery<HanMuc>({ queryKey: ['settings', 'plan'], queryFn: async () => (await api.get<HanMuc>('/settings/plan')).data })
  if (!data) return <div className="py-8 text-center"><Loader2 className="mx-auto animate-spin text-muted-foreground" /></div>
  return (
    <div className="max-w-2xl space-y-4">
      <div className="rounded-lg border p-4">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Gói hiện tại</p>
        <p className="text-lg font-semibold">{data.goi?.ten ?? 'Tuỳ chỉnh'}</p>
        <p className="text-sm text-muted-foreground">{data.goi?.moTa ?? 'Gói theo thoả thuận riêng — không giới hạn theo gói chuẩn.'}</p>
      </div>
      <div className="divide-y rounded-lg border">
        {DONG.map((d) => {
          const gh = data.gioiHan[d.k]
          const dung = data.dangDung[d.k]
          const pt = gh ? Math.min(100, Math.round((dung / gh) * 100)) : 0
          return (
            <div key={d.k} className="flex items-center gap-4 p-3">
              <span className="w-40 text-sm">{d.ten}</span>
              <div className="h-2 flex-1 overflow-hidden rounded-full bg-muted">{gh ? <div className={pt >= 100 ? 'h-full bg-destructive' : 'h-full bg-primary'} style={{ width: `${pt}%` }} /> : null}</div>
              <span className="w-28 text-right text-sm tabular-nums">{dung} / {gh == null ? 'không giới hạn' : gh}</span>
            </div>
          )
        })}
        <div className="flex items-center justify-between p-3 text-sm">
          <span>Ẩn thương hiệu nền tảng</span>
          <span className="text-muted-foreground">{data.gioiHan.anThuongHieuNenTang ? 'Có' : 'Không'}</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">Cần nâng gói hoặc tăng hạn mức, liên hệ quản trị nền tảng.</p>
    </div>
  )
}
